<div class="row mt-3 contido-50vh">
    <div class="col-12">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">Nº de Parcelas</th>
                    <th scope="col">Valor da Parcela</th>
                    <th scope="col">Valor Total</th>
                    <!-- <th scope="col">Cet a.a</th> -->
                </tr>
            </thead>
            <tbody *ngIf="simulacao">
                <tr *ngFor="let plano of simulacao.planos">
                    <th scope="row">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 (change)="changeRadioPlano(plano)">
                        </div>
                    </th>
                    <td>{{ plano.plano }}</td>
                    <td>{{ plano.prestacao | currency:'BRL' }}</td>
                    <td>{{ plano.prestacao * plano.plano | currency:'BRL' }}</td>
                    <!-- <td>% {{ plano.cetAnual }}</td> -->
                </tr>
            </tbody>
            <tfoot *ngIf="!simulacao">
                <tr>
                    <td colspan="4">
                        <div class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>

<div class="row fixed-bottom">
    <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-light mr-4" (click)="back()">Voltar</button>
        <button class="btn btn-primary ml-4" (click)="next()" [disabled]="!planoSelecionado">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="simulando"></span>
            Simular esta opção
        </button>
    </div>
</div>